import type { ReactNode } from 'react';
import styled from 'styled-components';

import { Flex } from '@/components/base';
import Typo from '@/components/Typography/Typo';

type Props = {
  title: ReactNode;
  rightNode?: ReactNode;
};

const SettingHeader = (props: Props) => {
  return (
    <SettingHeaderStyle>
      <Wrapper a="center" j="space-between">
        <Typo weight="sb" type="label2">
          {props.title}
        </Typo>
        {props.rightNode}
      </Wrapper>
    </SettingHeaderStyle>
  );
};

export default SettingHeader;

export const SettingHeaderStyle = styled.div`
  position: relative;
  width: 100%;
  height: 56px;
  z-index: 2;
  border-bottom: 1px solid ${(props) => props.theme.colors.gray300};
`;

const Wrapper = styled(Flex)`
  height: 100%;
  padding: 0 32px;
`;
